<template>
  <article class="capacity_view" v-if="charged">
    <section
      class="capacity_view__header_background"
      :style="{'background-color': getCompany().personalize.colors.principal}"></section>
    <section class="capacity_view__container">
      <section class="capacity_view__container--header">
        <div class="capacity_view__header--section">
          <img
            class="header_logo"
            :src="getCompany().personalize.app_logo.url"
            alt="">
        </div>
        <p class="capacity_view__header--title">
          Descarga la app <br>
          {{ getCompany().company_name }}
        </p>
        <div class="capacity_view__header--section header">
          <img
            class="store_button"
            src="https://s3-us-west-2.amazonaws.com/karrottsportlife/emails/google_button@2x.png"
            alt="">
          <img
            class="store_button"
            src="https://s3-us-west-2.amazonaws.com/karrottsportlife/emails/appstore_button@2x.png"
            alt="">
        </div>
      </section>
      <section class="capacity_view__container--capacity">
        <div
          class="capacity_view__container--full_access"
          :style="{backgroundColor: getCompany().personalize.colors.principal, borderColor: getCompany().personalize.colors.principal}">
          <p>Aforo actual</p>
          <p class="access_time">{{current_capacity}}</p>
        </div>
        <div
          class="capacity_view__container--prev_access"
          :style="{color: getCompany().personalize.colors.principal, borderColor: getCompany().personalize.colors.principal}">
          <p>Disponible</p>
          <p class="access_time">{{max_capacity - current_capacity}}</p>
        </div>
        <div
          class="capacity_view__container--resume">
          <div class="capacity_view__capacity_resume">
            <p>Aforo permitido</p>
            <div class="">
              <p class="capacity_view__capacity_resume--time"><v-icon >people</v-icon>{{max_capacity}}</p>
            </div>
          </div>
          <div class="capacity_view__capacity_resume">
            <p>Ocupación</p>
            <p class="capacity_view__capacity_resume--time">{{ current_capacity > 0 && max_capacity > 0 ? Number.parseInt((current_capacity * 100) / max_capacity) : 0 }}%</p>
          </div>
          <!-- <div class="capacity_view__capacity_resume">
            <p class="capacity_view__capacity_resume--message">Tiempo máximo <br>dentro de gimnasio</p>
            <p class="capacity_view__capacity_resume--time">90 min.</p>
          </div> -->
        </div>
      </section>
    </section>
  </article>
</template>

<script>
export default {
  data(){
    return{
      max_capacity:0,
      current_capacity: 0,
      charged: false,
      myRequestInterval: null,
    }
  },
  mounted(){
    var vm = this
    console.log(vm.getCompany());
    vm.findCurrentCapacity()
    this.myRequestInterval=setInterval(function(){
      vm.findCurrentCapacity()
      console.log(vm.getCompany());
    },10000);
  },
  methods: {
    findCurrentCapacity() {
      try {
        this.$http.get("app/locations/current_capacity",{headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()}})
        .then(function(response){
          console.log(response);
          this.current_capacity = response.body.meta.current_capacity
          this.max_capacity = response.body.meta.max_capacity
          this.charged = true
        }, function(response){
          console.log("ERROR");
          console.log(response);
        })
      } catch (e) {
        alert(e.message)
      }
    }
  },
  beforeDestroy(){
    clearInterval(this.myRequestInterval)
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/views/access/CapacityView.vue